export * from './protheus-date.pipe';
